import formValidation from 'formvalidation/es6/core/Core';
import Bootstrap3 from 'formvalidation/es6/plugins/Bootstrap3';
import DefaultSubmit from 'formvalidation/es6/plugins/DefaultSubmit';
import SubmitButton from 'formvalidation/es6/plugins/SubmitButton';
import Declarative from 'formvalidation/es6/plugins/Declarative';
import Trigger from 'formvalidation/es6/plugins/Trigger';
import Recaptcha from 'formvalidation/es6/plugins/Recaptcha';

const fieldsToValidate = ['startFreeTrial[firstName]', 'startFreeTrial[email]', 'startFreeTrial[password]'];
const params = new URL(window.location.href).searchParams;
const version = params.get("version") ?? 'default';

function pushDataLayer({ type, field, errorMessage, errorValidator }) {
    const isRecaptcha = field === 'g-recaptcha-response';
    const fieldName = isRecaptcha ? 'recaptcha' : field.split("[")[1].split("]")[0];

    const eventData = {
        event: type === 'valid' ? "start_free_form_field_validated" : "start_free_form_field_error",
        field_name: fieldName,
        start_free_version: version,
    };

    if (type === 'invalid') {
        eventData.error_message = isRecaptcha ? 'Invalid recaptcha' : errorMessage;
        eventData.error_validator = errorValidator || '';
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventData);
}

(function ready(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
})(() => {
    let badEmail;
    const jsonTranslationsElement = document.querySelector('#json_translations');
    const reCaptchaSiteKeyV3 = jsonTranslationsElement ? JSON.parse(jsonTranslationsElement.innerHTML).reCaptchaSiteKeyV3 : null;
    const recaptchaTokenElement = document.querySelector('#free-trial-form [name="g-recaptcha-enterprise-response"]');
    const validatedFields = [];
    const fieldsWithError = [];

    [].forEach.call(document.querySelectorAll('#free-trial-form .form-fieldset input'), (inputElement) => {
        inputElement.addEventListener('input', function onInput(e) {
            if (this.value !== '') {
                this.classList.add('not-empty');
            } else {
                this.classList.remove('not-empty');
            }
        });
        if (inputElement.value !== '') {
            inputElement.classList.add('not-empty');
        } else {
            inputElement.classList.remove('not-empty');
        }
    });

    if (document.querySelector('#free-trial-form .password')) {
        const PasswordContainer = document.querySelector('#free-trial-form .password');
        const togglePassword = document.querySelector('#free-trial-form .password button');
        togglePassword.addEventListener('click', (e) => {
            const inputPassword = document.querySelector('#free-trial-form .password input');
            PasswordContainer.classList.toggle('visible');
            if (inputPassword.getAttribute('type') === 'password') {
                inputPassword.setAttribute('type', 'text');
            } else {
                inputPassword.setAttribute('type', 'password');
            }
        });
    }

    if (document.querySelector('#free-trial-form [type=email]').parentElement.querySelector('.server-side-error')) {
        const serverErrorMessageElement = document.querySelector('#free-trial-form [type=email]').parentElement.querySelector('.server-side-error');
        badEmail = {
            value: document.querySelector('#free-trial-form [type=email]').value,
            message: serverErrorMessageElement.textContent,
        };
        serverErrorMessageElement.parentElement.removeChild(serverErrorMessageElement);
    }

    const customDomainExists = function () {
        if (typeof badEmail !== 'undefined') {
            return {
                validate(input) {
                    return {
                        valid: input.value !== badEmail.value,
                        message: badEmail.message,
                    };
                },
            };
        }
        return {
            validate() {
                return {
                    valid: true,
                };
            },
        };
    };

    const noEmojiErrorMessage = document.querySelector('[name="startFreeTrial[firstName]"]').getAttribute('data-fv-regexp___message') || '';
    const noEmoji = function () {
        return {
            validate(input) {
                return {
                    valid: !/\p{Extended_Pictographic}/gu.test(input.value),
                    message: noEmojiErrorMessage,
                };
            },
        };
    };

    const plugins = {
        trigger: new Trigger({
            event: {
                'startFreeTrial[firstName]': 'blur',
                'startFreeTrial[email]': 'blur',
                'startFreeTrial[password]': 'blur',
            },
        }),
        bootstrap3: new Bootstrap3(),
        defaultSubmit: new DefaultSubmit(),
        submitButton: new SubmitButton(),
        declarative: new Declarative({
            html5Input: true,
        }),
    };
    if (document.querySelector('#free-trial-form #captchaContainer')) {
        plugins.recaptcha = new Recaptcha({
            element: 'captchaContainer',
            siteKey: process.env.INVISIBLE_RECAPTCHA_SITE_KEY,
            message: JSON.parse(document.querySelector('#json_translations').innerHTML).reCaptchaErrorMessage,
            size: 'invisible',
            badge: 'bottomleft',
        });
    }

    function loadRecaptchaScript(siteKey, callback) {
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`;
        script.async = true;
        script.onload = callback;
        document.head.appendChild(script);
    }

    const fv = formValidation(document.querySelector('#free-trial-form'), {
        fields: {
            'startFreeTrial[firstName]': {
                validators: {
                    noEmoji: {},
                },
            },
            'startFreeTrial[email]': {
                validators: {
                    customDomainExists: {},
                },
            },
            'g-recaptcha-enterprise-response': {
                validators: {
                    promise: {
                        promise: function (input) {
                            return new Promise(function (resolve, reject) {
                                if (recaptchaTokenElement.value !== '') {
                                    resolve({
                                        valid: true,
                                        message: 'reCAPTCHA V3 already available',
                                    });
                                    return;
                                }
                                if (reCaptchaSiteKeyV3 && recaptchaTokenElement) {
                                    loadRecaptchaScript(reCaptchaSiteKeyV3, () => {
                                        grecaptcha.enterprise.ready(() => {
                                            grecaptcha.enterprise
                                                .execute(reCaptchaSiteKeyV3, { action: 'start_free_form_submit' })
                                                .then((token) => {
                                                    if (recaptchaTokenElement) {
                                                        recaptchaTokenElement.value = token;
                                                    }
                                                    resolve({
                                                        valid: true,
                                                        message: 'reCAPTCHA V3 verified successfully',
                                                    });
                                                })
                                                .catch((error) => {
                                                    reject({
                                                        valid: true, // Submit the form even without a token for V3 captcha
                                                        message: 'Error executing reCAPTCHA V3: ' + error.message,
                                                    });
                                                });
                                        });
                                    });
                                } else {
                                    // If the reCAPTCHA site key is not available
                                    resolve({
                                        valid: true, // Submit the form even without a token for V3 captcha
                                        message: 'reCAPTCHA V3 site key is not available',
                                    });
                                }
                            });
                        },
                    },
                },
            },
        },
        plugins,
    })
        .registerValidator('customDomainExists', customDomainExists)
        .registerValidator('noEmoji', noEmoji)
        .on('core.form.validating', () => {
            /**
             * Dodanie Elementu Link do drzewa DOM
             * Adding a Link Element to the DOM Tree
             */
            const appToLink = document.createElement('a');
            appToLink.setAttribute('href', 'https://app.getresponse.com');
            document.body.appendChild(appToLink);
            /**
             * Wywołanie eventu na wstawionym elemencie w celu przypisania parametrów Analytics
             * Triggering an event on an inserted element to assign Analytics parameters
             */
            const event = new MouseEvent('mousedown');
            Object.defineProperty(event, 'target', { value: appToLink, enumerable: true });
            document.dispatchEvent(event);
            /**
             * Wyciągnięcie parametrów z wstawionego linku (_ga & _gl)
             * Extracting parameters from inserted link (_ga & _gl)
             */
            const urlToAPP = event.target.getAttribute('href');
            const urlSearchParams = new URL(urlToAPP);
            const paramsGA = new URLSearchParams(urlSearchParams.search).getAll('_ga');
            const paramsGL = new URLSearchParams(urlSearchParams.search).getAll('_gl');
            /**
             * Przypisanie parametrów _ga => gaSessionId & _gl => gaLinkerParam
             * Parameter assignment _ga => gaSessionId & _gl => gaLinkerParam
             */
            document.querySelector('#free-trial-form [name="startFreeTrial[gaSessionId]"]').value = paramsGA ?? '';
            document.querySelector('#free-trial-form [name="startFreeTrial[gaLinkerParam]"]').value = paramsGL ?? '';
            /**
             * Usunięcie wstawionego elementu link
             * Deleting an inserted link element
             */
            appToLink.remove();
        })
        .on('core.form.valid', () => {
            document.querySelectorAll('.sso-buttons .sso-btn').forEach((button) => {
                button.disabled = true;
            });
            document.querySelector('#free-trial-form [name="startFreeTrial[submit]"]').disabled = true;
        })
        .on('core.field.valid', (field) => {
            if(!validatedFields.includes(field)){
                if (field === 'g-recaptcha-response'|| fieldsToValidate.includes(field)) {
                    pushDataLayer({ type: 'valid', field });
                }

                validatedFields.push(field)
                //removes from error if it's there
                if(fieldsWithError.find(item => item.name === field)){
                    fieldsWithError.splice(0, fieldsWithError.length, ...fieldsWithError.filter(item => item.name !== field));
                }
            }
        })
        .on('core.field.invalid', (field) => {
            const isRecaptcha = field === 'g-recaptcha-response';
            const fieldHasError = fieldsWithError.some(item => item.name === field);
        
            // recaptcha
            if (isRecaptcha && !fieldHasError) {
                pushDataLayer({
                    type: 'invalid',
                    field,
                    errorMessage: 'Invalid recaptcha',
                    errorValidator: 'invalid_recaptcha'
                });
        
                fieldsWithError.push({ name: field });
        
                // Removes from validated array if there's one
                const filteredValidated = validatedFields.filter(item => item !== field);
                validatedFields.splice(0, validatedFields.length, ...filteredValidated);
        
                return;
            }
        
           // other fields
            if (!fieldsToValidate.includes(field)) return;
        
            const input = document.querySelector(`#free-trial-form [name="${field}"]`);
            const errorContainer = input?.parentElement?.querySelector('.fv-plugins-message-container .help-block');
        
            if (!errorContainer) return;
        
            const errorMessage = errorContainer.innerText;
            const errorValidator = errorContainer.getAttribute('data-validator');
        
            const existingError = fieldsWithError.find(item => item.name === field);
            const validatorChanged = existingError && existingError.validator !== errorValidator;
        
            if (!existingError || validatorChanged) {
                pushDataLayer({ type: 'invalid', field, errorMessage, errorValidator });
        
                if (validatorChanged) {
                    // Removes all other errors from array for this filed name
                    const filteredErrors = fieldsWithError.filter(item => item.name !== field);
                    fieldsWithError.splice(0, fieldsWithError.length, ...filteredErrors);
                }
        
                fieldsWithError.push({ name: field, validator: errorValidator });
        
                //  Removes from validated array if there's one 
                const filteredValidated = validatedFields.filter(item => item !== field);
                validatedFields.splice(0, validatedFields.length, ...filteredValidated);
            }
        });

        window.addEventListener('pageshow', (event) => {
            if (event.persisted) {
                document.querySelector('#free-trial-form [name="startFreeTrial[submit]"]').disabled = false;
                document.querySelectorAll('.sso-buttons .sso-btn').forEach((button) => {
                    button.disabled = false;
                });
            }
        });

    if (typeof badEmail !== 'undefined') {
        fv.validateField('startFreeTrial[email]');
    }
    ['[name="startFreeTrial[firstName]"]', '[name="startFreeTrial[email]"]', '[name="startFreeTrial[password]"]'].forEach((inputSelector) => {
        document
            .querySelector('#free-trial-form')
            .querySelector(inputSelector)
            .addEventListener('focus', (e) => {
                fv.resetField(e.target.name);
            });
        document
            .querySelector('#free-trial-form')
            .querySelector(inputSelector)
            .addEventListener('blur', (e) => {
                if (e.relatedTarget && e.relatedTarget.classList.contains('sso-btn')) {
                    fv.resetField(e.target.name);
                }
            });
    });

    ['[name="startFreeTrial[firstName]"]', '[name="startFreeTrial[email]"]', '[name="startFreeTrial[password]"]'].forEach((inputSelector) => {
        document
            .querySelector('#free-trial-form')
            .querySelector(inputSelector)
            .addEventListener('blur', (e) => {
                e.target.value = e.target.value.trim();
                if (e.target.nextElementSibling.className === 'help-block php-error') {
                    e.target.nextElementSibling.remove();
                }
            });
    });

    const passwordTests = {
        testLength() {
            return /^.{8,100}/.test(this.value);
        },
        testAlphaNum() {
            return /^(?=.*[a-zA-Z])(?=.*[0-9])/.test(this.value);
        },
        testLowerUpper() {
            return /.*(?=.*[a-z])(?=.*[A-Z]).*/.test(this.value);
        },
        testSpecials() {
            return /.*[\s~`!@#$%^&*+=\-[\]\\';,/{}|\\":<>?()._].*/.test(this.value);
        },
    };

    document.querySelector('#free-trial-form [type=password]').addEventListener('input', function onInput() {
        const inputElement = this;
        Object.keys(passwordTests).forEach((testName) => {
            const testResult = passwordTests[testName].bind(inputElement)();
            if (testResult !== true) {
                document.querySelector('#free-trial-form .password-tips').querySelector(`.${testName}`).classList.remove('is-valid');
            } else {
                document.querySelector('#free-trial-form .password-tips').querySelector(`.${testName}`).classList.add('is-valid');
            }
        });
    });


    window.ga =
        window.ga ||
        function initGA(...args) {
            (window.ga.q = window.ga.q || []).push(args);
        };
    window.ga.l = +new Date();
    window.ga(() => {
        setTimeout(() => {
            document.querySelector('[name="startFreeTrial[gaClientId]"]').value = window.ga.getAll()[0].get('clientId');
        }, 1000);
    });
});
